// extracted by mini-css-extract-plugin
module.exports = {"taskbarContainer":"taskbar_taskbarContainer__mGqGs","taskbar":"taskbar_taskbar__BeqE9","link":"taskbar_link__r9ZM_","active":"taskbar_active__uM2Zy","label":"taskbar_label__3mqt5"};